module.exports = __webpack_public_path__ + "static/media/bg-3.3b0f9645.jpg";